import { TripleDotsIcon } from "@cynthai/icons";
import { tv } from "tailwind-variants";

import Button from "./Button";
import Dropdown from "./Dropdown";
import type { SelectItem, SlotClassNames } from "./types";

const actionsDropdown = tv({
  slots: { trigger: "shrink-0" },
  variants: {
    size: {
      icon: { trigger: "" },
      sm: { trigger: "p-1.5" },
    },
  },
  defaultVariants: { size: "icon" },
});

export interface ActionsDropdownProps<T extends string> {
  items: SelectItem<T>[];
  onAction: (key: NoInfer<T>) => void;
  label?: string;
  triggerSize?: "icon" | "sm";
  classNames?: SlotClassNames<ReturnType<typeof actionsDropdown>>;
  className?: string;
}

export function ActionsDropdown<T extends string = string>({
  items,
  onAction,
  label = "Actions",
  triggerSize = "icon",
  classNames,
  className,
}: Readonly<ActionsDropdownProps<T>>) {
  if (items.length === 0) return null;

  return (
    <Dropdown<T>
      items={items}
      onAction={onAction}
      closeOnAction
      aria-label={label}
      className={className}
    >
      <Button
        size="unsized"
        variant="icon"
        className={actionsDropdown({ size: triggerSize }).trigger({
          className: classNames?.trigger,
        })}
        aria-label={label}
      >
        <TripleDotsIcon />
      </Button>
    </Dropdown>
  );
}
